export enum InboxViews {
  showAllMessages,
  showMessage,
  unsupportedInboxSection,
  unknownMessageId,
}

export enum ReadFilter {
  all = '0',
  notRead = '1',
  alreadyRead = '2',
}

export const mapReadFilterToAnalyticsValues = {
  [ReadFilter.all]: 'tutti',
  [ReadFilter.alreadyRead]: 'letti',
  [ReadFilter.notRead]: 'non_letti',
};

export const readFilterQueryParamKey = 'read-filter';
